module.exports = __webpack_public_path__ + "img/1-1-home.c5650b76.jpg";